import { render } from "./UnscheduledVisitModal.vue?vue&type=template&id=579e56c2&scoped=true"
import script from "./UnscheduledVisitModal.js?vue&type=script&lang=js"
export * from "./UnscheduledVisitModal.js?vue&type=script&lang=js"

import "./UnscheduledVisitModal.vue?vue&type=style&index=0&id=579e56c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579e56c2"]])

export default __exports__